import React from 'react'
import { Link } from 'react-router-dom'
import Footer from '../components/Footer'

const Terms: React.FC = () => {
  return (
    <div className="bg-white text-gray-800 min-h-screen flex flex-col privacy-policy-container">
      <div className="container mx-auto px-4 py-10 max-w-3xl flex-grow">
        <header className="mb-10">
          <Link to="/" className="text-primary hover:text-accent text-sm font-medium inline-flex items-center">
            ← Back to Syentist
          </Link>
          <h1 className="text-3xl font-bold mt-8 text-accent">Terms &amp; Conditions</h1>
        </header>
        <p className="text-gray-600 leading-relaxed">
          Formal terms documents are customized by engagement. To request Terms &amp; Conditions or contracting information, contact{' '}
          <a href="mailto:hi@syentist.com" className="text-primary hover:text-accent font-medium underline-offset-4 hover:underline">
            hi@syentist.com
          </a>
          .
        </p>
      </div>
      <Footer />
    </div>
  )
}

export default Terms
